/* Register der Beschreibungen zu Prüfungen (ADR 0003): zu jeder `id` ein Übersetzungsschlüssel mit Erklärung des Problems (Ursache, Folge, Abhilfe).
 * Der Prüf-Dialog zeigt sie als (i) am Befund. Als Tabelle, damit der i18n-Test die Schlüssel findet. Ohne DOM. */
export const CHECK_INFO: Record<string, string> = {
  'core.c_leak': 'chk.i.core.c_leak',
  'core.c_leak_skipped': 'chk.i.core.c_leak_skipped',
  'core.c_no_brushes': 'chk.i.core.c_no_brushes',
  'core.c_no_changelevel': 'chk.i.core.c_no_changelevel',
  'core.c_no_light': 'chk.i.core.c_no_light',
  'core.c_no_spawns': 'chk.i.core.c_no_spawns',
  'core.c_start_missing': 'chk.i.core.c_start_missing',
  'core.c_start_multi': 'chk.i.core.c_start_multi',
  'core.c_start_outside': 'chk.i.core.c_start_outside',
  'core.c_start_solid': 'chk.i.core.c_start_solid',
  'core.c_stuck': 'chk.i.core.c_stuck',
  'core.c_tex_missing': 'chk.i.core.c_tex_missing',
  'core.c_void_ents': 'chk.i.core.c_void_ents',
  'core.c_dm_monsters': 'chk.i.core.c_dm_monsters',
  'core.c_dm_no_start': 'chk.i.core.c_dm_no_start',
  'core.c_dm_spawns': 'chk.i.core.c_dm_spawns',
  'perf.hidden': 'chk.i.perf.hidden',
  'perf.tiny': 'chk.i.perf.tiny',
  'perf.many_faces': 'chk.i.perf.many_faces',
  'perf.lights': 'chk.i.perf.lights',
  'perf.monsters': 'chk.i.perf.monsters',
  'perf.textures': 'chk.i.perf.textures',
  'perf.entity_faces': 'chk.i.perf.entity_faces',
  'perf.tex_scale': 'chk.i.perf.tex_scale',
  'perf.no_hint': 'chk.i.perf.no_hint',
  'perf.noclip': 'chk.i.perf.noclip',
  'cx.detail_level': 'chk.i.cx.detail_level',
  'cx.prisms_in_world': 'chk.i.cx.prisms_in_world',
  'cx.vis_load': 'chk.i.cx.vis_load',
  'cx.underwater': 'chk.i.cx.underwater',
  'lint.invalid_brush': 'chk.i.lint.invalid_brush',
  'lint.no_compiler_fgd': 'chk.i.lint.no_compiler_fgd',
  'lint.off_grid': 'chk.i.lint.off_grid',
  'lint.dangling': 'chk.i.lint.dangling',
  'lint.dead_trigger': 'chk.i.lint.dead_trigger',
  'lint.zfight': 'chk.i.lint.zfight',
  'lint.tex_distort': 'chk.i.lint.tex_distort',
  'lint.npot_texture': 'chk.i.lint.npot_texture',
  'lint.dark_light': 'chk.i.lint.dark_light',
  'lint.no_env_light': 'chk.i.lint.no_env_light',
  'lint.hint_mixed': 'chk.i.lint.hint_mixed',
  'lint.hint_entity': 'chk.i.lint.hint_entity',
  'chk.map_type': 'chk.i.chk.map_type',
  'core.c_tex_list': 'chk.i.core.c_tex_list',
  'wad_list': 'chk.i.wad_list'
};
